import { Link } from "@mui/material";
import cookie from "js-cookie";
import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import login from "../../../../../../components/Layout/util/login";
import fetcher from "../../../../../dataProvider";
import useLocalStorage from "../../../../../hooks/useLocalStorage";
import { setToken, setUserDetail } from "../../../../../redux/actions";
import { setUserData } from "../../../../../redux/slices/user";
import TagManager from "react-gtm-module";
import auth from "../../../../../../components/Layout/util/auth";
import { isEmpty } from "lodash";
import eventBus from "../../../../../../util/eventBus";
import { CommonContext } from "../../../../../../components/helper/commonContext";
import { useRouter } from "next/router";

const LoginForm = ({ toggleSnackbar }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm();

  const [, setAccessToken] = useLocalStorage("accessToken", null);
  const [, setRefreshToken] = useLocalStorage("refreshToken", null);

  const [notVerified, setNotVerified] = useState(false);
  const [email, setEmail] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const commonContext = useContext(CommonContext);
  const router = useRouter();

  const dispatch = useDispatch();

  const onFormSubmit = (data) => {
    setEmail(data.username);
    loginApi({
      email: data.username,
      password: data.password,
    });
  };

  const { mutate: loginApi } = useMutation(
    (user) => fetcher.post(`v1/auth/login`, user),
    {
      onSuccess: (data) => {
        if (typeof window !== "undefined") {
          localStorage.setItem("userCreatedTime", data?.user?.createdAt);
        }
        if (data) {
          dispatch(setUserData(data?.user));
          const accessToken = data.tokens?.access?.token;
          const refreshToken = data.tokens?.refresh?.token;

          cookie.set("token", refreshToken, { expires: 2 });
          console.log("cookie", cookie.get("_ga"));
          let ga_cookies = data?.user?.googleAnalyticsId || [];
          if (!ga_cookies.includes(cookie.get("_ga"))) {
            ga_cookies = [...ga_cookies, cookie.get("_ga")];
            updateGACookies(data?.user?.id, ga_cookies);
          }
          const tagManagerArgs = {
            dataLayer: {
              event: "login",
              Status: "Success",
              userId: data?.user?.id,
              Method: "Email",
            },
          };
          TagManager.dataLayer(tagManagerArgs);
          login(
            data.tokens.access.token,
            data.user.name,
            data.user.email,
            data.user.id,
            data.user.role
          );

          setAccessToken(accessToken);
          setRefreshToken(refreshToken);

          dispatch(
            setToken({
              accessToken: accessToken,
              accessToken: refreshToken,
              isLoggedIn: true,
            })
          );

          dispatch(
            setUserDetail({
              ...data.user,
            })
          );

          toggleSnackbar({
            show: true,
            status: "success",
            message: "Hi, You are logged in  " + data.user.name,
          });

          if (window != "undefined") {
            if (
              !data?.user?.mobile &&
              (localStorage.getItem("nftAction") == "BuyNFT" ||
                localStorage.getItem("nftAction") == "SellNFT")
            ) {
              eventBus.dispatch("openCapturePhoneModal", {
                function_name: "capturephone",
              });
            } else {
              commonContext.setMobileUpdated(true);
              if (localStorage.getItem("nftAction") == "openNormalCalculator") {
                commonContext.setCalculator(true);
              } else if (localStorage.getItem("nftAction") == "BuyNFT") {
                if (localStorage?.getItem("is_tradable") == "true") {
                  router.push({
                    pathname: "/payment/BuyTradeNft",
                    query: { tier_id: localStorage?.getItem("tierId") },
                  });
                } else {
                  router.push({
                    pathname: "/payment/BuyNowNft",
                    query: { tier_id: localStorage?.getItem("tierId") },
                  });
                }
              }
            }
          }
        }
      },
      onError: ({ response: { data } }) => {
        const tagManagerArgs = {
          dataLayer: {
            event: "login",
            Status: "failed",
            userId: data?.user?.id,
            Method: "Email login",
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        if (data?.code) {
          if (data.message == "Please verify your email") {
            sendVerifyEmail();
            setNotVerified(true);
            setCounter(30);
          } else {
            setNotVerified(false);
          }
          setError("username", { type: "custom", message: data.message });
          setError("password", { type: "custom", message: "Try again" });
        }
      },
    }
  );

  const updateGACookies = async (id, GA_Ids) => {
    try {
      const userData = await fetcher.patch(`/v1/user/${id}`, {
        googleAnalyticsId: GA_Ids,
      });
      if (!isEmpty(userData)) {
        dispatch(setUserData(response));
      }
    } catch (error) {
      console.log("Error", error?.response?.data);
    }
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const { mutate: sendVerifyEmail } = useMutation(
    (user) =>
      fetcher.post(`v1/auth/send-verification-email`, {
        email: email,
      }),
    {
      onSuccess: (data) => {
        toggleSnackbar({
          show: true,
          status: "success",
          message: "Verification link send, check email",
        });
      },
      onError: ({ response: { data } }) => {
        toggleSnackbar({
          show: true,
          status: "error",
          message: "Something went wrong",
        });
      },
    }
  );
  const [counter, setCounter] = React.useState();

  React.useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const verifyLink = () => {
    sendVerifyEmail();
    setCounter(30);
  };

  const r = auth();

  const handleForgotpassword = () => {
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "loggedIn",
          ctaName: "Forgot Password",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "Guest",
          ctaName: "Forgot Password",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const handleLoginclick = () => {
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "loggedIn",
          ctaName: "Login",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "Guest",
          ctaName: "Login",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const [agree, setAgree] = useState(true);

  const checkboxHandler = () => {
    setAgree(!agree);
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <div className="inputBox">
        <input
          type="text"
          placeholder="Email*"
          {...register("username", {
            required: "Enter Email",
          })}
        />
        {errors.username && (
          <div style={{ color: "red" }}>{errors.username.message}</div>
        )}
      </div>
      <div className="inputBox">
        <input
          type={passwordShown ? "text" : "password"}
          placeholder="Enter Password*"
          {...register("password", { required: "Enter Password" })}
        />
        <span style={{ cursor: "pointer" }} onClick={togglePassword}>
          <img
            style={{ marginLeft: "-29px", width: "22px", height: "22px" }}
            src={
              passwordShown
                ? "/images/login/eye-off.svg"
                : "/images/login/eye.svg"
            }
          />
        </span>
        {errors.password && (
          <div style={{ color: "red" }}> {errors.password.message}</div>
        )}
      </div>
      <div className="forget-password">
        <Link href="/forgot-password" onClick={() => handleForgotpassword()}>
          Forgot password?
        </Link>
      </div>
      <div className="checkbox_text_login_signup">
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginTop: "6px",
          }}
        >
          <input
            type="checkbox"
            style={{ width: "15px", position: "relative", top: "4px" }}
            id="agree"
            onChange={checkboxHandler}
            defaultChecked={agree}
          />
          <label style={{ fontSize: "14px", marginLeft: "5px" }}>
            {" "}
            I agree to{" "}
            <span
              style={{ cursor: "pointer", color: "#e14084" }}
              onClick={() => window.open("/terms", "_blank")}
            >
              T&#38;C{" "}
            </span>
            and{" "}
            <span
              style={{ cursor: "pointer", color: "#e14084" }}
              onClick={() => window.open("/privacy", "_blank")}
            >
              Privacy Policy{" "}
            </span>
            and to receive communication &#47; notifications on email &#47;
            WhatsApp &#47; SMS from FanTiger.
          </label>
        </div>
      </div>
      {notVerified && (
        <>
          <div>
            We’ve sent a verification link to your email id. Please check and
            verify.
          </div>
          <div className="verify-link">
            <Link
              onClick={() => verifyLink()}
              className={counter > 0 ? "disabled-link" : "enabled-link"}
            >
              Resend Verification Link{" "}
              {counter > 0 && <span>in 00:{counter}</span>}{" "}
            </Link>
          </div>
        </>
      )}
      <div className="login-button01">
        <button
          type="submit"
          className="btn"
          onClick={() => handleLoginclick()}
          disabled={!agree}
        >
          Login
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
